import { ref } from "vue";

/* routerでセットするため、provideできない */
export const loginStatus = ref(false);